/**
 * Every save in Pricing.tsx PATCHes the whole pricing group, echoing every other rate
 * back from what the API last sent. Left alone, that echo ships `color` for
 * rates the edit never touched -- defeating the modals' "only send it when it
 * changed" guard, and answering 500 against a booking service that predates
 * the column (CFTB-3499, CFTB-3502). An omitted key means "leave as is":
 * PricingGroups::UpdateService only writes what the request sent.
 */
export function withoutEchoedColor<T extends Record<string, any>>(lessonRate: T) {
  const rest = { ...lessonRate };

  delete rest.color;

  return rest;
}
